import React from "react";
import { NavLink } from "react-router-dom";

import styles from "./ModalHidStarMenu.module.scss";

interface MenuItemType {
  text: string;
  target: string;
  img: string;
  imgActive: string;
}

interface ModalSaveModeMenuProps {
  activePath: string;
  handleItemClick: (index: number) => void;
  menuData: MenuItemType[];
}

const ModalHidStarMenu: React.FC<ModalSaveModeMenuProps> = ({
  activePath,
  handleItemClick,
  menuData,
}) => {
  // Helper function to determine if a menu item should be active
  const isMenuItemActive = (item: MenuItemType) => {
    // Special handling for "Screens" - should be active for all screen-related routes
    if (item.text === "Screens") {
      const screenRoutes = [
        "/saved-library/video/",
        "/saved-library/store/",
        "/saved-library/animation/",
        "/saved-library/onboarding/",
      ];
      return screenRoutes.some((route) => activePath.includes(route));
    }

    // For other items, use the original logic
    return activePath.includes(item.target);
  };

  return (
    <div className={styles.modalContainer}>
      {menuData.map((item: MenuItemType, index: number) => {
        const isActive = isMenuItemActive(item);
        return (
          <NavLink
            to={item.target}
            className={`${styles.modalMenuItem} ${isActive ? styles.modalMenuItemActive : ""}`}
            key={index}
            onClick={() => handleItemClick(index)}
          >
            <img
              src={isActive ? item.imgActive : item.img}
              alt="appsMenuIcon"
            />
            <p>{item.text}</p>
          </NavLink>
        );
      })}
    </div>
  );
};

export default ModalHidStarMenu;
